<template>
  <div class="unitindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header">
        <el-row style="display: flex; align-items: center">
          <el-col :span="4">
            <span>工资统计列表</span>
          </el-col>
          <el-col :span="14"> &nbsp; </el-col>
          <!-- 时间选择 -->
          <el-col :span="5">
            <el-date-picker
              value-format="yyyy-MM"
              format="yyyy-MM"
              v-model="pickerDate"
              type="month"
              :editable="false"
              placeholder="请选择月份(默认上月)"
              @change="handleDateChange"
            >
            </el-date-picker>
          </el-col>
          <!-- 下载 -->
          <el-col :span="1">
            <el-button
              icon="el-icon-download"
              type="info"
              :loading="downloadLoading"
              @click="download"
            ></el-button>
          </el-col>
        </el-row>
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="5">
          <el-input
            placeholder="请输入姓名"
            v-model="personName"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="userSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">&nbsp;</el-col>
        <el-col :span="15">
          <el-form :model="formInline" class="demo-form-inline">
            <el-row>
              <el-col :span="6">
                <el-form-item label="高温补贴" label-width="100px">
                  <el-input
                    v-model="formInline.highTemperaturePay"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="1">&nbsp;</el-col> -->
              <el-col :span="6">
                <el-form-item label="过节费" label-width="60px">
                  <el-input
                    v-model="formInline.festivitiesPay"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1">&nbsp;</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-button type="success" @click="onSubmit">保存</el-button>
                  <el-button type="primary" @click="saveBackups"
                    >确认工资</el-button
                  >
                  <el-button
                    type="warning"
                    @click="jump('/empsalarystats/queryBackups')"
                    >查看已确认</el-button
                  >
                  <el-button type="primary" @click="jumpToPerfStats"
                    >绩效统计</el-button
                  >
                </el-form-item></el-col
              >
            </el-row>
          </el-form>
        </el-col>
        <!-- <el-col :span="1">&nbsp;</el-col> -->
      </el-row>
      <!-- 筛选 -->

      <!-- 绩效工资计算 -->
      <el-row style="margin-bottom: 12px">
        <el-col :span="12">
          <el-form :model="perfForm" inline>
            <el-form-item label="绩效工资总额">
              <el-input
                v-model="perfForm.totalAmount"
                placeholder="请输入绩效工资总额"
                style="width: 180px"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="calcPerformanceSalary"
                >确认计算</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <TzTable :tableData="statsList" :columns="columns" :summary="true" />
      <!-- 表格 -->

      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import {
  pageList,
  saveBackups,
  updateMembersWagesInfo,
  downloadWelfare
} from '@/api/salarystats'
import { updateWelfare, welfareList, saveWelfare } from '@/api/welfare'
import fileDownload from 'js-file-download'
import TzTable from '@/components/tz-table/Index.vue'
export default {
  components: {
    TzTable
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      downloadLoading: false, // 下载
      editUnit: {},
      statsList: [],
      formInline: {
        id: '',
        highTemperaturePay: '',
        festivitiesPay: ''
      },
      perfForm: {
        totalAmount: '60450'
      },
      personName: '', // 员工姓名
      pickerDate: '', //日期 时间戳
      columns: [
        {
          field: 'personId',
          title: '工号',
          width: '100'
        },
        {
          field: 'personName',
          title: '姓名',
          width: '70'
        },
        {
          field: 'cardNo',
          title: '身份证号',
          width: '100'
        },

        {
          title: '基本工资',
          type: 'isEdit',
          width: '100',

          payload: {
            field: 'basePay'
          }
        },
        // {
        //   field: 'lifePay',
        //   title: '年限工资'
        // },
        // {
        //   field: 'certPay',
        //   title: '持证工资'
        // },
        // {
        //   field: 'titlePay',
        //   title: '职称工资'
        // },
        {
          field: 'postPay',
          title: '职位工资'
        },
        // {
        //   field: 'performance',
        //   title: '绩效工资'
        // },
        // {
        //   field: 'leaderPay',
        //   title: '组长提成'
        // },
        {
          field: 'total',
          title: '合计1',
          width: '100'
        },
        {
          field: 'weightedPerfValue',
          title: '绩效值',
          width: '80'
        },
        {
          field: 'performanceGrade',
          title: '绩效等级',
          width: '80'
        },
        {
          field: 'performance',
          title: '绩效工资',
          width: '100'
        },
        {
          title: '奖金',
          type: 'isEdit',
          width: '90',
          payload: {
            field: 'bonus'
          }
        },
        {
          field: 'highTemperaturePay',
          title: '高温补贴',
          width: '70'
        },
        {
          field: 'festivitiesPay',
          title: '过节费',
          width: '60'
        },
        {
          title: '补发',
          type: 'isEdit',
          payload: {
            field: 'complementPay'
          }
        },
        {
          field: 'total2',
          title: '合计2'
        },
        {
          field: 'total3',
          title: '合计3'
        },
        {
          title: '社保',
          type: 'isEdit',
          payload: {
            field: 'se'
          }
        },
        {
          title: '公积金',
          type: 'isEdit',
          payload: {
            field: 'pf'
          }
        },
        {
          title: '个税',
          type: 'isEdit',
          payload: {
            field: 'tax'
          }
        },
        {
          title: '扣款',
          type: 'isEdit',
          payload: {
            field: 'deductPay'
          }
        },
        {
          field: 'payableSalary',
          title: '应发工资',
          width: '100'
        },
        {
          title: '操作',
          width: '80',
          type: 'btn',
          payload: [
            {
              name: '保存',
              type: 'primary',
              click: (row) => {
                console.log('单条保存', row)
                this.saveChange(row)
              }
            }
          ]
        }
      ],
      unitname: ''
    }
  },
  created() {
    //默认显示上月日期
    let date = new Date(new Date() - 30 * 24 * 3600 * 1000)
    let dateString =
      date.getFullYear() +
      (date.getMonth() + 1 < 10 ? '0' : '') +
      (date.getMonth() + 1)
    let monthValue = dateString.substring(dateString.length - 2)
    let yearValue = dateString.slice(0, -2)
    dateString = yearValue + '-' + monthValue
    this.pickerDate = this.pickerDate ? this.pickerDate : dateString
    this.getListBydate()
  },
  methods: {
    //选择日期搜索
    handleDateChange(dialogPickerDate) {
      if (dialogPickerDate == null) {
        this.pickerDate = ''
      }
      this.page = 1
      this.getStatsList()
      this.getListBydate()
    },
    // handleSizeChange(val) {
    //   this.size = val
    //   this.getStatsList()
    // },
    // handleCurrentChange(val) {
    //   this.page = val
    //   this.getStatsList()
    // },
    //根据时间获取补贴
    getListBydate() {
      let welparams = {
        date: this.pickerDate
      }
      welfareList(welparams).then((res) => {
        console.log(res.data, '根据时间获取补贴')
        if (res.code == 200) {
          let infos = res.data
          this.formInline.highTemperaturePay = infos.highTemperaturePay
          this.formInline.festivitiesPay = infos.festivitiesPay
          this.formInline.id = infos.id
        } else {
          this.formInline.highTemperaturePay = ''
          this.formInline.festivitiesPay = ''
          this.formInline.id = ''
        }
      })
    },
    // 列表
    getStatsList() {
      let unitparams = {
        date: this.pickerDate,
        personName: this.personName
        // pageSize: this.size,
        // pageNum: this.page
      }
      pageList(unitparams).then((res) => {
        console.log(res.data, '单位列表')
        if (res.code == 200) {
          if (res.data) {
            // 绩效值直接展示（不再乘以工资系数）
            for (var idx = 0; idx < res.data.length; idx++) {
              var rawItem = res.data[idx]
              rawItem.weightedPerfValue =
                Math.floor(
                  (Number(rawItem.performanceValue) || 0) * 10000
                ) / 10000
            }
            // 按绩效值从高到低排序
            this.statsList = res.data.sort(function (a, b) {
              var va = Number(a.weightedPerfValue) || 0
              var vb = Number(b.weightedPerfValue) || 0
              return vb - va
            })
          }
          // let infoArr = res.data.records
          // this.total = res.data.total
          // this.statsList = infoArr
        }
      })
    },
    // 确认工资
    saveBackups() {
      var self = this
      var month = this.pickerDate

      // 1. 先收集绩效工资数据，保存到 t_members_wages_info
      var perfUpdateList = []
      for (var i = 0; i < this.statsList.length; i++) {
        var item = this.statsList[i]
        if (item.performance != null && item.performance !== '') {
          perfUpdateList.push({
            personId: item.personId,
            date: month,
            performance: item.performance
          })
        }
      }

      var doBackup = function () {
        let data = { date: month }
        saveBackups(data).then((res) => {
          if (res.code == 200) {
            self.$message({ message: '备份成功', type: 'success' })
          }
        })
      }

      if (perfUpdateList.length > 0) {
        // 先保存绩效工资到 t_members_wages_info
        updateMembersWagesInfo(perfUpdateList).then((res) => {
          if (res.code == 200) {
            doBackup()
          } else {
            self.$message({ type: 'error', message: '绩效工资保存失败' })
          }
        })
      } else {
        doBackup()
      }
    },

    // 一键保存
    onSubmit() {
      this.$loading({
        text: '信息更新中'
      })
      if (this.formInline.id) {
        console.log(this.formInline, '---修改---')
        let tempData = [
          {
            id: this.formInline.id,
            date: this.pickerDate,
            highTemperaturePay: this.formInline.highTemperaturePay,
            festivitiesPay: this.formInline.festivitiesPay
          }
        ]
        updateWelfare(tempData).then((res) => {
          console.log(res.data, '更新')
          this.$loading().close()
          if (res.code == 200) {
            this.$message({
              message: '更新成功',
              type: 'success'
            })
            this.getStatsList()
          } else {
            this.$message({
              message: res.data,
              type: 'error'
            })
          }
        })
      } else {
        console.log(this.formInline, '---新增---')
        let tempData = [
          {
            date: this.pickerDate,
            highTemperaturePay: this.formInline.highTemperaturePay,
            festivitiesPay: this.formInline.festivitiesPay
          }
        ]
        saveWelfare(tempData).then((res) => {
          console.log(res.data, '新增')
          this.$loading().close()
          if (res.code == 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.getStatsList()
          } else {
            this.$message({
              message: '新增失败',
              type: 'error'
            })
          }
        })
      }
    },
    //下载
    download() {
      this.downloadLoading = true
      var data = {
        personName: this.personName,
        date: this.pickerDate
      }
      downloadWelfare(data).then((res) => {
        fileDownload(res, `${this.pickerDate}工资统计.xlsx`)
      })
      this.downloadLoading = false
    },
    // 编辑保存
    saveChange(infos) {
      console.log(infos)
      this.$loading({
        text: '信息更新中'
      })
      let updateparams = [
        {
          date: this.pickerDate,
          personId: infos.personId,
          complementPay: infos.complementPay,
          bonus: infos.bonus,
          se: infos.se,
          pf: infos.pf,
          tax: infos.tax,
          deductPay: infos.deductPay,
          monthBasic: infos.basePay //基本工资
        }
      ]
      updateMembersWagesInfo(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getStatsList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
      })
    },

    // 模糊查询
    userSearch() {
      this.page = 1
      this.getStatsList()
    },
    // 跳转到绩效统计页面，默认查询上个月
    jumpToPerfStats() {
      var month = this.pickerDate || this.getLastMonthStr()
      this.$router.push({
        path: '/perfstats',
        query: { month: month }
      })
    },
    // 获取上个月 yyyy-MM
    getLastMonthStr() {
      let date = new Date()
      date.setDate(0)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      return [y, m].join('-')
    },
    // 绩效工资计算：输入总额 × 个人绩效值 / 所有参与人员绩效值之和 × 工资系数
    calcPerformanceSalary() {
      var amount = Number(this.perfForm.totalAmount)
      if (isNaN(amount) || amount < 0) {
        this.$message({ type: 'warning', message: '请输入有效的绩效工资总额' })
        return
      }
      // 先保存旧的绩效工资，用于重新计算应发工资
      var oldPerfMap = {}
      for (var k = 0; k < this.statsList.length; k++) {
        oldPerfMap[this.statsList[k].personId] =
          Number(this.statsList[k].performance) || 0
      }

      if (amount === 0) {
        // 总额为0，所有人绩效工资为0
        for (var z = 0; z < this.statsList.length; z++) {
          var itemZ = this.statsList[z]
          if (itemZ.isPerformanceCalc === 1) {
            itemZ.performance = 0
            // 合计3 = 合计1 + 绩效工资 + 合计2
            itemZ.total3 =
              Math.floor(
                (Number(itemZ.total) + 0 + Number(itemZ.total2)) * 10000
              ) / 10000
            var oldPerfZ = oldPerfMap[itemZ.personId] || 0
            itemZ.payableSalary =
              Math.floor(
                (Number(itemZ.total) -
                  oldPerfZ +
                  0 +
                  Number(itemZ.total2) -
                  Number(itemZ.pf) -
                  Number(itemZ.se) -
                  Number(itemZ.tax) -
                  Number(itemZ.deductPay)) *
                  10000
              ) / 10000
          } else {
            itemZ.performance = null
            // 绩效工资为0，合计3 = 合计1 + 0 + 合计2
            itemZ.total3 =
              Math.floor(
                (Number(itemZ.total) + Number(itemZ.total2)) * 10000
              ) / 10000
          }
        }
        this.statsList = JSON.parse(JSON.stringify(this.statsList))
        this.$message({ type: 'success', message: '绩效工资计算完成' })
        return
      }
      // 筛选参与绩效的人员
      var participants = this.statsList.filter(function (item) {
        return item.isPerformanceCalc === 1 && Number(item.performanceValue) > 0
      })
      if (participants.length === 0) {
        this.$message({ type: 'warning', message: '没有参与绩效的人员数据' })
        return
      }
      // 计算参与人员绩效值总和 = Σ(绩效值)
      var perfWeightedSum = 0
      for (var i = 0; i < participants.length; i++) {
        perfWeightedSum += Number(participants[i].performanceValue) || 0
      }
      if (perfWeightedSum <= 0) {
        this.$message({
          type: 'warning',
          message: '绩效值总和为0，无法计算'
        })
        return
      }
      // 第一轮：计算每个人的原始绩效工资并向下取整到元
      var perfResults = []
      for (var j = 0; j < this.statsList.length; j++) {
        var item = this.statsList[j]
        if (item.isPerformanceCalc === 1 && Number(item.performanceValue) > 0) {
          var perfSalary =
            (amount * Number(item.performanceValue)) / perfWeightedSum
          perfResults.push({
            index: j,
            personId: item.personId,
            rawValue: perfSalary,
            flooredValue: Math.floor(perfSalary)
          })
        }
      }

      // 第二轮：计算差额并分配（补1元给小数点后面部分最大的人）
      var sumFloored = 0
      for (var m = 0; m < perfResults.length; m++) {
        sumFloored += perfResults[m].flooredValue
      }
      var remainder = Math.floor(amount) - sumFloored
      if (remainder > 0) {
        // 按小数部分从大到小排序（从多往少）
        perfResults.sort(function (a, b) {
          var fracA = a.rawValue - a.flooredValue
          var fracB = b.rawValue - b.flooredValue
          if (fracB === fracA) return b.rawValue - a.rawValue
          return fracB - fracA
        })
        // 逐个补1元
        for (var n = 0; n < remainder && n < perfResults.length; n++) {
          perfResults[n].flooredValue += 1
        }
        // 恢复原始顺序
        perfResults.sort(function (a, b) {
          return a.index - b.index
        })
      }

      // 第三轮：将计算结果设置到列表
      var perfIdx = 0
      for (var p = 0; p < this.statsList.length; p++) {
        var item2 = this.statsList[p]
        if (
          item2.isPerformanceCalc === 1 &&
          Number(item2.performanceValue) > 0
        ) {
          var result = perfResults[perfIdx]
          perfIdx++
          item2.performance = result.flooredValue
          // 合计3 = 合计1 + 绩效工资 + 合计2
          item2.total3 =
            Math.floor(
              (Number(item2.total) +
                Number(item2.performance) +
                Number(item2.total2)) *
                10000
            ) / 10000
          // 重新计算应发工资 = 合计1 + 新绩效工资 + 合计2 - 社保 - 公积金 - 个税 - 扣款（合计1不含绩效工资）
          var oldPerf = oldPerfMap[item2.personId] || 0
          var newPayable =
            Number(item2.total) -
            oldPerf +
            Number(item2.performance) +
            Number(item2.total2) -
            Number(item2.pf) -
            Number(item2.se) -
            Number(item2.tax) -
            Number(item2.deductPay)
          item2.payableSalary = Math.floor(newPayable * 10000) / 10000
        } else {
          // 不参与绩效的人员，绩效工资置空
          item2.performance = null
          // 绩效工资为0，合计3 = 合计1 + 0 + 合计2
          item2.total3 =
            Math.floor(
              (Number(item2.total) + Number(item2.total2)) * 10000
            ) / 10000
        }
      }
      // 触发视图更新
      this.statsList = JSON.parse(JSON.stringify(this.statsList))
      this.$message({ type: 'success', message: '绩效工资计算完成' })
    }
  },
  mounted() {
    this.getStatsList()
  }
}
</script>

<style lang="scss" scoped>
.unitindex {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item_label {
    color: blue;
  }
}

::v-deep .el-table {
  overflow-x: auto;
}
::v-deep .el-table__header-wrapper {
  overflow: visible;
}
::v-deep .el-table__body-wrapper {
  overflow: visible;
}
::v-deep .el-table__footer-wrapper {
  overflow: visible;
}
::v-deep.el-table .el-table__footer-wrapper .cell {
  font-size: 16px;
  color: red;
}
::v-deep .el-table::after {
  position: relative;
}
::v-deep .el-table--scrollable-x .el-table__body-wrapper {
  overflow: visible;
}
</style>
